import React, { useEffect, useState } from 'react';
import Loading from '../../loading/Loading';
import TableLayout, { TD, selectSx } from '../../ui/TableLayout';
import { EditBtn, DeleteBtn, Actions } from '../../ui/ActionButtons';
import Apis from '../../Apis';
import { FiCheckSquare, FiSquare } from 'react-icons/fi';
import axios from 'axios';
import { showAlert } from '../../ui/dialog';

const COLS = ['Descrição', 'Parcelamento', 'Permitir Venda', 'Ações'];
const headers = () => ({ 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') });

export default function ListaFormaPagamento() {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [perPage, setPerPage] = useState(25);
  const [inativo, setInativo] = useState('-1');

  const fetchData = (q = search, pp = perPage, inv = inativo) => {
    setLoading(true);
    axios.get(
      `${Apis.urlListarFormasPagamento}?pesquisa=${q}&inativo=${inv}&qtd_registros=${pp}`,
      { headers: headers() }
    )
      .then(res => setData(res.data.registros || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchData(); }, []); // eslint-disable-line

  const handlePerPage = (val) => { setPerPage(val); fetchData(search, val); };

  const handlePermitirVenda = async (id) => {
    const item = data.find(d => String(d.id) === String(id));
    let permitidas = data
      .filter(d => d.inativo == 0)
      .map(d => ({ id_forma_pagto: d.id }));

    if (item?.inativo == 0) {
      permitidas = permitidas.filter(d => String(d.id_forma_pagto) !== String(id));
    } else {
      permitidas.push({ id_forma_pagto: id });
    }

    try {
      setLoading(true);
      const res = await axios.patch(Apis.urlAlterarPermissaoFormaPagamento, { permitidas }, { headers: headers() });
      showAlert({ title: 'Sucesso', text: res.data.retorno?.mensagem || 'Permissão atualizada!', icon: 'success' });
    } catch (err) {
      showAlert({ title: 'Atenção', text: err.response?.data?.retorno?.mensagem || 'Erro ao atualizar.', icon: 'error', dangerMode: true });
    } finally {
      fetchData();
    }
  };

  const Toolbar = (
    <select value={inativo} onChange={e => { const v = e.target.value; setInativo(v); fetchData(search, perPage, v); }} style={selectSx}>
      <option value="-1">Todos</option>
      <option value="0">Ativos</option>
      <option value="1">Inativos</option>
    </select>
  );

  if (loading) return <Loading />;

  return (
    <TableLayout
      title="Formas de Pagamento"
      icon={null}
      count={data.length}
      columns={COLS}
      search={{ value: search, onChange: setSearch, placeholder: 'Buscar por descrição…', onSubmit: () => fetchData() }}
      pagination={{ value: perPage, onChange: handlePerPage }}
      toolbar={Toolbar}
      fab={{ show: true, label: 'forma de pagamento', path: 'cadastrar-forma-pagamento' }}
      emptyMessage="Nenhuma forma de pagamento encontrada."
    >
      {data.map((c, i) => (
        <tr key={c.id}
          style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc' }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#eff6ff')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#fff' : '#f8fafc')}
        >
          <TD left uppercase>{c.descricao}</TD>
          <TD>{String(c.parcelamento) === '0' ? 'Não' : 'Sim'}</TD>
          <TD>
            <button
              title={String(c.inativo) === '0' ? 'Clique para desativar' : 'Clique para ativar'}
              onClick={() => handlePermitirVenda(c.id)}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: String(c.inativo) === '0' ? '#10b981' : '#94a3b8',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: 4, borderRadius: 6,
              }}
            >
              {String(c.inativo) === '0'
                ? <FiCheckSquare size={18} />
                : <FiSquare size={18} />}
            </button>
          </TD>
          <TD>
            <Actions>
              <EditBtn to={`/alterar-forma-pagamento/${c.id}`} />
              <DeleteBtn url={Apis.urlDeletarFormaPagamento} id={c.id} redirect="listar-forma-pagamento" component="Forma de Pagamento" texto={`Deseja realmente excluir a forma de pagamento ${c.descricao}`} />
            </Actions>
          </TD>
        </tr>
      ))}
    </TableLayout>
  );
}
